<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <img :src="corporateLogo ? corporateLogo : require('@/../public/img/Color-Alternate.png')" alt="Corporate Logo"
        class="corporate-logo" />
      <h3 class="modal-title">Import Member Process</h3>
      <div class="modal-subtitle mt-4 mb-4 text-left">
        <p class="mb-2 text-center"><strong>Successfully imported with:</strong></p>
        <ul class="result-list">
          <li>
            <span class="text-failed">Failed = {{ data?.fail_count || 0 }}</span>
          </li>
          <li>
            <span class="text-succeeded">Succeeded = {{ data?.success_count || 0 }}</span>
          </li>
          <li v-if="uniqueDuplicateEmails && uniqueDuplicateEmails.length > 0">
            <span class="text-duplicated">Duplicate Emails = {{ uniqueDuplicateEmails.join(', ') }}</span>
          </li>
          <li v-if="data?.validation_errors && data.validation_errors.length > 0">
            <div class="mt-2 text-failed">
              <span style="font-weight: 600;">Validation Errors:</span>
              <div v-for="(error, index) in data.validation_errors" :key="'ve-'+index" class="validation-error-item">
                {{ error }}
              </div>
            </div>
          </li>
        </ul>
      </div>

      <button type="button" class="btn btn-primary btn-submit" @click="closeModal">
        OK
      </button>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onBeforeUnmount } from 'vue';

export default {
  name: "ImportResultModal",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      required: true,
      default: () => ({
        fail_count: 0,
        success_count: 0,
        duplicate_emails: [],
        validation_errors: []
      })
    }
  },
  setup(props, { emit }) {
    const corporateLogo = ref(null);
    let timer = null;

    corporateLogo.value = localStorage.getItem('corporateLogo');

    const uniqueDuplicateEmails = computed(() => {
        if (!props.data || !props.data.duplicate_emails) return [];
        return [...new Set(props.data.duplicate_emails.map(email => email.replace(/["[\]]/g, '')))];
    });

    const closeModal = () => {
      clearTimeout(timer);
      emit("close");
    };

    watch(() => props.isVisible, (newVal) => {
        if (newVal) {
            document.body.style.overflow = 'hidden';
            timer = setTimeout(() => {
                closeModal();
            }, 10000); // 10 seconds auto close
        } else {
            document.body.style.overflow = '';
            clearTimeout(timer);
        }
    });

    onBeforeUnmount(() => {
        document.body.style.overflow = '';
        if (timer) clearTimeout(timer);
    });

    return {
      corporateLogo,
      uniqueDuplicateEmails,
      closeModal,
    };
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  width: 90%;
  max-width: 450px;
  background: #ffffff;
  border-radius: 12px;
  padding: 40px 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.corporate-logo {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 200px;
  max-height: 80px;
  height: auto;
  margin-bottom: 20px;
  object-fit: contain;
}

.modal-title {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
  color: #333;
  margin-bottom: 5px;
}

.modal-subtitle {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 0.9rem;
  color: #666;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.mt-4 {
  margin-top: 1.5rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.text-succeeded {
    color: #28a745;
    font-weight: 600;
}

.text-failed {
    color: #dc3545;
    font-weight: 600;
}

.text-duplicated {
    color: #ff9800;
    font-weight: 600;
    word-break: break-all;
    word-wrap: break-word;
}

.result-list {
    list-style-type: none;
    padding-left: 0;
    margin-top: 0;
    display: inline-block;
    text-align: left;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
}

.result-list li {
    margin-bottom: 8px;
    font-size: 0.95rem;
}

.btn-submit {
  width: 100%;
  padding: 12px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 8px;
}

.btn-primary {
  color: #fff;
  background-color: var(--primary-color, #f93e3e);
  border-color: var(--primary-border, #f93e3e);
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #e02020;
}

.validation-error-item {
    color: #dc3545;
    font-size: 0.85rem;
    font-weight: 400;
    line-height: 1.4;
    word-break: break-word;
    margin-top: 10px;
    white-space: pre-line;
}
</style>
